export default __webpack_public_path__ + "e10a80e4e1d94b7e7ef02632f96023dc.png";